export const environment = {
  production: true,
  version: require('../../package.json').version,
  gdprUrl : 'https://privacy.zeotap.com/ucms/api/v1/user',
  siteKey : '6LfnW7QUAAAAAOW6x3faixKh9jzfEZaQIwXPUDPS'
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts